<!--加载中组件
		this.$dialogMethod.showLoading('xxx');打开loading
		this.$dialogMethod.closeLoading();关闭loading-->
<template>
	<transition class="loader">
		<div v-show="isLoading" class="contentBox" @click.stop="closeLoading">
			<div class="mask"></div>
			<div  class="contents flexCenterColumn">
				<div class="spinner">
					<div class="spinner"></div>
				</div>
				<p>{{urlName}}</p>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		components: {},
		props: [],
		computed: {},
		data() {
			return {
				isLoading: false,
				urlName: ''
			}
		},
		created() {},
		watch: {},
		methods: {
			showLoading(urln) {
				this.urlName = urln;
				this.isLoading = true;
				setTimeout(()=>{
					this.isLoading = false
				},7000)
			},
			closeLoading() {
				this.isLoading = false
			}
		}
	}
</script>
<style>
	
	.mask {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 99;
	}
	
	.contents {
		z-index: 999;
		position: fixed;
		right: 0;
		left: 0;
		top: 30%;
		width: 2rem;
		margin: auto;
		padding: 0;
		background: white;
		border-radius: .06rem;
		color: black;
		margin-top: .7rem;
		text-align: center;
		padding: 0.1rem;
	}

	.loader {
		text-align: center;
	}
	
	.spinner {
		width: 30px;
		height: 30px;
		background-color: #105aab;
		margin: 30px auto;
		-webkit-animation: rotateplane 1.2s infinite ease-in-out;
		animation: rotateplane 1.2s infinite ease-in-out;
	}
	
	@-webkit-keyframes rotateplane {
		0% {
			-webkit-transform: perspective(120px)
		}
		50% {
			-webkit-transform: perspective(120px) rotateY(180deg)
		}
		100% {
			-webkit-transform: perspective(120px) rotateY(180deg) rotateX(180deg)
		}
	}
	
	@keyframes rotateplane {
		0% {
			transform: perspective(120px) rotateX(0deg) rotateY(0deg);
			-webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)
		}
		50% {
			transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
			-webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg)
		}
		100% {
			transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
			-webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
		}
	}
</style>